import { render, staticRenderFns } from "./DynamicFormContent.vue?vue&type=template&id=3bf155e4&scoped=true&"
import script from "./DynamicFormContent.vue?vue&type=script&lang=js&"
export * from "./DynamicFormContent.vue?vue&type=script&lang=js&"
import style0 from "./DynamicFormContent.vue?vue&type=style&index=0&id=3bf155e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bf155e4",
  null
  
)

/* custom blocks */
import block0 from "@/locales/components/CbsDynamicFormConfig.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2FUsers%2Flike%2FDocuments%2FComay%2FSources%2FFe%2Flink-fe%2Fsrc%2Fcomponents%2Fcbs-dynamic-form%2FDynamicFormContent.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports